{
    "firebase": {
        "apiKey": "AIzaSyDNxA5hLj0Gvf5hyCON65ldIAGcHNNrFP8",
        "authDomain": "stout-test.firebaseapp.com",
        "databaseURL": "https://stout-test-default-rtdb.firebaseio.com",
        "projectId": "stout-test",
        "storageBucket": "stout-test.firebasestorage.app",
        "messagingSenderId": "140639808471",
        "appId": "1:140639808471:web:2b6d63895949c849383992"
    },
    "clientName": "Stout Test",
    "pdfViewerKey": "414b8ab91f3f4dd6b01fbf1ed15e80c3",
    "domains": ["stout-test.flightlinedata.com"],
    "tally_url": ""
}
